<template>
  <div ref="container" class="container">
    <div class="title">{{$t(title)}}</div>
    <textarea @keydown="change()" @keyup="change()" @change="change()" class="component-text-area" ref="textarea"  v-model="model"></textarea>
  </div>
</template>

<script>

export default {
  name: 'ui-textarea',
  props:{
    val: {
        type: String,
    },
    autoSize:{default:false},
    title:{default:""}
  },
  /*
  computed:{
    getVal(){
      return this.val;
    }
  },
  */
  data:function(){
    return {
      on:false,
      inputValue:""
    }
  },
  mounted(){
    this.container=this.$refs['container'];  
    this.textArea=this.$refs['textarea'];
  },
  methods:{
   change(){
     if(!this.autoSize){
       return;
     }
     // reset box to zero height?
     this.container.style.height="0px";
     this.$nextTick(()=>{
      var scrollHeight=this.textArea.scrollHeight;
      
      // cap max height
      if(scrollHeight>150){
        scrollHeight=150;
      }

      this.container.style.height=scrollHeight+"px";
     
     })
     
    
   }
  },
  computed:{
    model:{
      get(){
        return this.val;
      },
      set(v){
        this.$emit('input', v);
      }
    }
  }
 
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container{
  margin-bottom:15px;
  position:relative;
  height:150px;
}

.title{
  padding:0 5px;
  position:absolute;
  font-size:.7em;
  display:inline-block;
  background-color:#FFFFFF;
  top: -8px;
  left: 5px;
  z-index:1;
}
.component-text-area{
  width:100%;
  height:inherit;
  border:1px solid #707070;
  border-radius:4px;
  outline: none;
  font-size:1.0em;
  padding:10px 10px;
  resize: none;
  /*padding-top:10px;*/
}


</style>
